import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PostList from '@containers/post-list';
const getPostData = (url) => {
    return new Promise((resolve, reject) => {
        axios.get(url)
            .then((res) => resolve(res.data))
            .catch(reject);
    });
};
const Index = () => {
    const [postList, setPostList] = useState();
    useEffect(() => {
        getPostData(`./assets/json/report.json?${new Date().getTime()}`)
            .then(data => setPostList(data));
    }, []);
    return (React.createElement("div", null,
        React.createElement(PostList, { postList: postList })));
};
export default Index;
